import { useCallback } from 'react';

export const calcPricing = (leadsCount) => {
  const leads = Math.max(0, leadsCount);
  let perLead = 3.00;
  let packageName = 'Starter';

  if (leads >= 1000) {
    perLead = 2.00;
    packageName = 'VIP';
  } else if (leads >= 350) {
    perLead = 2.50;
    packageName = 'Pro';
  } else {
    perLead = 3.00;
    packageName = 'Starter';
  }

  const total = leads * perLead;
  const subtotal = leads * 3.00; // Preço base é R$ 3,00
  const discountAmount = subtotal - total;
  const discount = subtotal > 0 ? discountAmount / subtotal : 0;

  return {
    subtotal,
    discount,
    discountAmount,
    total,
    leads,
    perLead,
    packageName
  };
};

export function usePricing(cartCount = 0) {
  const downloadPricingCSV = useCallback(() => {
    const rows = [];
    const steps = [25, 50, 100, 200, 300, 350, 500, 750, 1000, 1500, 2000];
    for (const qty of steps) {
      const c = calcPricing(qty);
      rows.push([
        c.packageName,
        qty,
        c.perLead.toFixed(2),
        `${(c.discount * 100).toFixed(0)}%`,
        c.total.toFixed(2),
      ]);
    }
    const header = [
      'Pacote',
      'Quantidade de Leads',
      'Preço por Lead (R$)',
      'Desconto Equivalente',
      'Preço Total (R$)',
    ];
    const csv = [header, ...rows].map((r) => r.join(',')).join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `tabela_precos_leadszone_${Date.now()}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  }, []);

  const pricing = calcPricing(cartCount);

  return { pricing, downloadPricingCSV };
}

